export const LOGIN_CARD_TITLE = 'Welcome back';
